import React, { Component } from 'react';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import { Table, Image, Segment, Popup, Icon, Grid } from 'semantic-ui-react';

import Error from '../../components/error';
import Loading from '../../components/loading';

import Location from './components/location';
import Audience from './components/audience';
import HashtagsAndMentions from './components/hashtags-and-mentions';
import Benchmark from './components/benchmark';
import Followers from './components/followers';
import AvgViews from './components/avg-views';
import AvgLikes from './components/avg-likes';
import AudienceCredibility from './components/audience-credibility';
import EngagementRate from './components/engagement-rate';
import PostsSummary from './components/posts-summary';

const _ = require('lodash');

const verticalMargin30 = {
  marginTop: 30,
  marginBottom: 30,
};

const girdPaddinghalfRem = {
  padding: '0.25rem'
};


const profileImageStyle = {
  width: 200,
  height: 'auto',
};

class Summary extends Component {
  constructor() {
    super();
    this.state = {};
    this.client = axios.create({
      // baseURL: process.env.REACT_APP_API_URL,
      baseURL: 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/profile',
      timeout: 10000,
    });

    axiosRetry(this.client, {
      retries: 3,
      delay: 100,
      retryCondition: error => !error.response || (error.response.status >= 500 && error.response.status <= 599),
    });
  }

  componentDidMount = () => {
    console.log(this.props.match);
    const { id } = this.props.match.params;

    const noop = _.noop();
    console.log(noop);

    console.log(`profileId: ${id}`);
    // put the email into local storage
    // https://www.npmjs.com/package/localStorage
    // https://www.npmjs.com/package/local-storage

    // create a form with name and email
    this.setState({
      profileId: id,
    });

    this.client.get(`/${id}`)
      .then(r => {
        const profile = r.data;
        console.log('profile', profile);
        console.log(profile.rawInstagramPosts);
        this.setState({
          loading: false,
          profile,
        });
      })
      .catch(error => {
        window.onerror(error);
        this.setState({
          error,
        });
      });
  }

  render = () => {
    const { profile, error } = this.state;

    const instagram = _.get(profile, 'instagram');
    const instagramAccountId = _.get(profile, 'instagramAccountId');

    if (profile && instagramAccountId) {
      return (
        <div style={{ textAlign: 'center', maxWidth: 900, margin: 'auto' }}>

          <div style={verticalMargin30}>
            <Image
              src={`https://pics.dyzio.co/${instagramAccountId}-hd.jpg`}
              onError={i => { i.target.src = `https://pics.dyzio.co/${instagramAccountId}.jpg`}}
              className="circular"
              centered
              style={profileImageStyle}
            />

            <h1 style={{fontSize: '220%', marginBottom: 5 }}>
              {_.upperCase(_.get(profile, 'name'))}
              {
                _.get(profile, 'instagramVerified') &&
                <Popup
                  trigger={<Icon name="check circle" color="blue" />}
                  content="verified account"
                />
              }
              {
                !_.get(profile, 'instagramVerified') &&
                <Popup
                  trigger={<Icon name="circle outline" color="grey" />}
                  content={`${_.get(profile, 'instagram')} is not verified by Instagram (blue tick)`}
                />
              }
            </h1>

            <Table basic="very" fluid textAlign="center" style={{marginTop: 5 }}>
              <Table.Body>
                <Table.Row>
                  <div>
                    <h3 style={{fontSize: '200%'}}>
                      <a className="profile"
                        href={`https://www.instagram.com/${instagram}`}
                          target="_blank">
                          @{instagram}
                      </a>
                      &nbsp;
                      <Popup
                        trigger={<Icon name="briefcase" color={_.get(profile, 'instagramBusinessAccount') ? 'pink' : 'grey'} />}
                        content={`${_.get(profile, 'instagramBusinessAccount') ? '' : 'Not an'} Instagram business account`}
                      />
                      {
                        _.get(profile, 'instagramPrivate') &&
                        <Popup
                          trigger={<Icon name="lock" color="red" />}
                          content={'This account is private'}
                        />
                      }
                    </h3>
                  </div>

                </Table.Row>
              </Table.Body>
            </Table>
          </div>

          <div style={verticalMargin30}>
            <Grid columns="3" stackable>
                <Grid.Column style={girdPaddinghalfRem}>
                  <Segment>
                    <Followers profile={profile} />
                  </Segment>
                </Grid.Column>
                <Grid.Column style={girdPaddinghalfRem}>
                  <Segment>
                    <Location profile={profile} />
                  </Segment>
                </Grid.Column>
                <Grid.Column style={girdPaddinghalfRem}>
                  <Segment>
                    <Audience profile={profile} />
                  </Segment>
                </Grid.Column>
                <Grid.Column style={girdPaddinghalfRem}>
                <Segment>
                  <AudienceCredibility profile={profile} />
                </Segment>
                </Grid.Column>
                <Grid.Column style={girdPaddinghalfRem}>
                  <Segment>
                    <AvgViews profile={profile} />
                  </Segment>
                </Grid.Column>
                <Grid.Column style={girdPaddinghalfRem}>
                  <Segment>
                    <AvgLikes profile={profile} />
                  </Segment>
                </Grid.Column>
                <Grid.Column style={girdPaddinghalfRem}>
                  <Segment>
                    <EngagementRate profile={profile} />
                  </Segment>
                </Grid.Column>
                <Grid.Column style={girdPaddinghalfRem}>
                  <Segment>
                    <Benchmark profile={profile} />
                  </Segment>
                </Grid.Column>
                <Grid.Column style={girdPaddinghalfRem}>
                  <Segment>
                    <HashtagsAndMentions profile={profile} />
                  </Segment>
                </Grid.Column>
            </Grid>
          </div>

          <div style={verticalMargin30}>
            <Grid columns="equal" fluid>
              <Grid.Column>
                <PostsSummary profile={profile} />
              </Grid.Column>
            </Grid>
          </div>

        </div>
      );
    }

    if (error) {
      return (
        <Error error={error} />
      );
    }

    return (
      <Loading resource="profile" />
    );
  }
}

export default Summary;



// WEBPACK FOOTER //
// ./src/containers/summary/index.js